<template>
	<div id="Infor">

		<div class="g-right-middle width800 ">
			<div class="info-tit float-left">基本信息</div>
			<div class="el-icon-edit float-right" @click="centerDialogVisible = true">修改</div>
			<el-dialog title="影片信息" :close-on-click-modal='false'  :visible.sync="centerDialogVisible"  center>
				<M_Ypxx></M_Ypxx>
			</el-dialog>
			<div class="g-base">
				<div class="float-left">
					<img :src="list.picture" width="260" height="360">
				</div>
				<div class="float-right g-base-p">
					<p>影片名称：{{list.movie_name}}</p>
					<p>影片类型：{{list.theme}}</p>
					<p>出品方：{{list.make}}</p>
					<p>筹备地点：{{list.prepare}}</p>
					<p>开机时间：{{list.start_time}}</p>
					<p>暂定拍摄地点：{{list.take_place}}</p>
					<p>暂定拍摄周期：{{list.take_period}}天</p>
					<p>项目简介：{{list.synopsis}}</p>
				</div>
				<div class="clearfix"></div>
			</div>
			<div class="info-tit">主创人员</div>
			<div class="g-base">
				<ul>
					<li class="float-left" v-for="(item,key) in list.crew_post">
						<img :src="item.images_url" width="150" height="210" :onerror="errorImg">
						<div class="zf-pic-foo2">
							<p class="g-wd-hidden">{{item.position}}：{{item.name}}</p>
							<p class="g-wd-hidden">代表作：{{item.representative}}</p>
						</div>
						<div class="m_zcry">
							<span class="el-icon-edit " @click="centerDialogVisible2=true;m_zcry(item.id)">修改</span>
							<span class="el-icon-minus " @click="del_zcry(key,item.id)">删除</span>
						</div>
					</li>
					<el-dialog title="主创人员"  :close-on-click-modal='false' :visible.sync="centerDialogVisible2"  center>
						<M_Zcry :name='name' :position='position' :representative='representative' :images_url='images_url'></M_Zcry>
					</el-dialog>
					<div class="clearfix"></div>
				</ul>
				<center>
					<div class=" el-icon-plus" @click="centerDialogVisible3 = true" style="margin-top: 40px;">新增</div>
					<el-dialog title="主创人员"  :close-on-click-modal='false' :visible.sync="centerDialogVisible3"  center>
						<M_Zcry_add></M_Zcry_add>
					</el-dialog>
				</center>
			</div>

			<div class="info-tit">招募演员</div>
			<div class="g-base">
				<div v-for="(item,key) in list.crew_recruit">
					<div class="float-left jz-zm-num2">
						{{key+1}}
					</div>
					<div class="float-left jz-zm-wd2">
						<p>
							<span class="float-left">
								{{item.nature}}：{{item.role_name}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
								<span class="el-icon-edit " @click="centerDialogVisible4 = true;m_zmyy(item.id)">修改</span>
								<el-dialog title="招募演员" :close-on-click-modal='false' :visible.sync="centerDialogVisible4" width="30%" center>
									<M_Zmyy :role_name='role_name' :synopsis='synopsis'></M_Zmyy>
								</el-dialog>
							</span>

							<div class="clearfix"></div>
						</p>
						<p>人物简介：{{item.synopsis}}</p>
					</div>
					<span class="float-right el-icon-minus" @click="del_zmyy(key,item.id)">删除</span>
					<div class="clearfix"></div>
				</div>
				<center>
					<div class=" el-icon-plus" @click="centerDialogVisible5 = true" style="margin-top: 40px;">新增</div>
					<el-dialog title="招募演员"  :close-on-click-modal='false' :visible.sync="centerDialogVisible5" width="30%" center>
						<M_Zmyy_add></M_Zmyy_add>
					</el-dialog>
				</center>
			</div>
			<div class="info-tit float-left">联系方式</div>

			<div class="clearfix"></div>
			<div class="g-base">
				<div v-for="(item,key) in list.crew_contact">
					<div class="float-left jz-zm-wd2">

						<p><span class="font_2em">姓名</span>：{{item.name}}</p>
						<p><span class="font_3em">手机号</span>：{{item.mobile}}</p>
						<p><span class="font_3em">微信号</span>：{{item.wechat}}</p>
						<p><span class="font_qqem">qq号</span>：{{item.qqnumber}}</p>
						<p><span class="font_2em">邮箱</span>：{{item.mail}}</p>
						<!-- <p><span class="font_4em">联系角色</span>：{{item.role}}</p> -->
					</div>
					<div class="el-icon-edit float-right" @click="centerDialogVisible6 = true;m_infor()">修改</div>
					<el-dialog title="联系方式" :close-on-click-modal='false' :visible.sync="centerDialogVisible6" width="40%" center>
						<M_Infor></M_Infor>
					</el-dialog>
					<div class="clearfix"></div>

				</div>
				<center>
					<div class=" el-icon-plus new_add_infor" @click="centerDialogVisible7 = true" style="margin-top: 40px;">新增</div>
					<el-dialog title="联系方式"  :close-on-click-modal='false' :visible.sync="centerDialogVisible7" width="30%" center>
						<M_Infor_add></M_Infor_add>
					</el-dialog>
				</center>
			</div>
		</div>
	</div>
</template>
<script>
	import storage from '../../storage/storage.js'
	import Axios from 'axios'
	import M_Ypxx from '@/components/group_admin/group_modify/M_Ypxx'
	import M_Zcry_add from '@/components/group_admin/group_modify/M_Zcry_add'
	import M_Zmyy_add from '@/components/group_admin/group_modify/M_Zmyy_add'
	import M_Zmyy from '@/components/group_admin/group_modify/M_Zmyy.vue'
	import M_Zcry from '@/components/group_admin/group_modify/M_Zcry.vue'
	import M_Infor from '@/components/group_admin/group_modify/M_Infor.vue'
	import M_Infor_add from '@/components/group_admin/group_modify/M_Infor_add.vue'

	export default {
		data() {
			return {
				errorImg: 'this.src="' + require('../../assets/mrimg2.jpg') + '"', //未上传时显示默认图片
				list: [], //默认渲染数据定义的list
				centerDialogVisible: false, //获取基本信息修改弹窗属性
				centerDialogVisible2: false, //获取主创信息修改弹窗属性
				centerDialogVisible3: false, //获取添加主创信息修改弹窗属性
				centerDialogVisible4: false, //获取修改招聘信息修改弹窗属性
				centerDialogVisible5: false, //获取添加招聘信息修改弹窗属性
				centerDialogVisible6: false, //获取添加招聘信息修改弹窗属性
				centerDialogVisible7: false, //获取添加招聘信息修改弹窗属性
				role_name: '',
				// nature: '',
				synopsis: '',
				name: '',
				position: '',
				representative: '',
				images_url: '',
			}
		},
		components: {
			M_Ypxx,
			M_Zcry_add,
			M_Zmyy_add,
			M_Zmyy,
			M_Zcry,
			M_Infor,
			M_Infor_add
		},
		methods: {
			m_infor(){
				var crew_contact=storage.get('crew_contact') //获取剧组联系信息数据

				for(var i=0;i<crew_contact.length;i++){
					storage.set('infor_name',crew_contact[i].name)  //联系方式：姓名
					storage.set('infor_mobile',crew_contact[i].mobile)  //联系方式：手机号
					storage.set('infor_qqnumber',crew_contact[i].qqnumber)  //联系方式：qq号
					storage.set('infor_wechat',crew_contact[i].wechat)  //联系方式：微信号
					// storage.set('infor_role',crew_contact[i].role)  //联系方式：角色
					storage.set('infor_mail',crew_contact[i].mail)  //联系方式：角色
					storage.set('infor_id',crew_contact[i].id)  //联系方式：当前联系信息条数id
					storage.set('infor_crew_id',crew_contact[i].crew_id)		//剧组所属id

				}
			},
			m_zmyy(id) {
				// debugger
				storage.set('m_zmyy_id', id) //存储当前指定条数id
				var crew = storage.get('crew_recruit') //存储数组进行存储
				for (var i = 0; i < crew.length; i++) {
					if (id == crew[i].id) {
						this.role_name = crew[i].role_name //遍历招募演员数据并赋值字段，通过props传递给子组件
						this.synopsis = crew[i].synopsis
						var nature = crew[i].nature
						var n = nature
						if (n == '男演员') {
							storage.set('m_nature', '1')
						}
						if (n == '女演员') {
							storage.set('m_nature', '2')
						}
						if (n == '老人演员') {
							storage.set('m_nature', '3')
						}
						if (n == '儿童演员') {
							storage.set('m_nature', '4')
						}
						if (n == '跟组演员') {
							storage.set('m_nature', '5')
						}
						if (n == '群众演员') {
							storage.set('m_nature', '6')
						}
						if (n == '特约演员') {
							storage.set('m_nature', '7')
						}
						if (n == '特技演员') {
							storage.set('m_nature', '8')
						}
						if (n == '特型演员') {
							storage.set('m_nature', '9')
						}
					}
				}
			},
			m_zcry(id) {
				storage.set('m_zcry_id', id) //存储当前指定条数id
				var crew_post = storage.get('crew_post') //存储timer数组进行存储
				for (var i = 0; i < crew_post.length; i++) {
					if (id == crew_post[i].id) {
						this.name = crew_post[i].name //遍历招募演员数据并赋值字段，通过props传递给子组件
						this.position = crew_post[i].position
						this.representative = crew_post[i].representative
						this.images_url = crew_post[i].images_url
					}
				}
			},
			del_zmyy(key, pid) {
				var id = storage.get('id')
				var api = 'https://api.yopoo.cn/api/centre/deleterecruit?cid=' + id + '&pid=' + pid //pid信息id，cid剧组信息id
				var token = storage.get('token')

				Axios.get(api, {
					headers: {
						'Authorization': token
					}
				}).then((res) => {
					if (res.data.code == 200) { //判断返回状态码
						this.$message({
							message: res.data.msg, //获取返回状态信息
							type: 'success',
							center: true
						});
						this.list.crew_recruit.splice(key, 1)
						this.list.crew_recruit.splice(pid, 1)
					}
					if (res.data.code == 202) { //判断返回状态码
						this.$message({
							message: res.data.msg, //获取返回状态信息
							type: 'error',
							center: true
						});
					}
				})
			},
			del_zcry(key, pid) {
				var id = storage.get('id')
				var api = 'https://api.yopoo.cn/api/centre/deletemain?cid=' + id + '&pid=' + pid //pid信息id，cid剧组信息id
				var token = storage.get('token')
				Axios.get(api, {
					headers: {
						'Authorization': token
					}
				}).then((res) => {
					if (res.data.code == 200) { //判断返回状态码
						this.$message({
							message: res.data.msg, //获取返回状态信息
							type: 'success',
							center: true
						});
						this.list.crew_post.splice(key, 1)
						this.list.crew_post.splice(pid, 1)
					}
					if (res.data.code == 202) { //判断返回状态码
						this.$message({
							message: res.data.msg, //获取返回状态信息
							type: 'error',
							center: true
						});
					}
				})
			},
			requestData(id) { //路由传过来的uid
				var api = "https://api.yopoo.cn/api/v1/crewminute?id=" + id
				this.$http.get(api).then((res) => {
						// console.log(res)
						this.list = res.body
						storage.set('movie_name', res.body.movie_name) //影片名称
						storage.set('make', res.body.make) //出品方
						storage.set('start_time', res.body.start_time) //开机时间
						storage.set('take_period', res.body.take_period) //拍摄周期
						storage.set('synopsis', res.body.synopsis) //影片简介
						storage.set('imgsrc', res.body.picture)
						storage.set('crew_recruit', res.body.crew_recruit)
						storage.set('crew_post', res.body.crew_post)
						storage.set('crew_contact', res.body.crew_contact)
						storage.set('prepare', res.body.prepare)
						//-------------判断剧组联系信息，有数据则不允许新增，无数据则显示新增-------------//
						var crew_contact=res.body.crew_contact
						if(crew_contact==''){
							$(function(){
								$('.new_add_infor').show()
							})
						}else{
							$(function(){
								$('.new_add_infor').hide()
							})
						}
						//-------------筹备地点信息判断-------------//

						//-------------拍摄地点信息判断-------------//
						var t_p = res.body.take_place
						if (t_p == '北京') {
							storage.set('take_place', '1')
						}
						if (t_p == '上海') {
							storage.set('take_place', '2')
						}
						if (t_p == '横店') {
							storage.set('take_place', '3')
						}
						if (t_p == '其他') {
							storage.set('take_place', '4')
						}
						//-------------影片类型信息判断-------------//
						var t = res.body.theme
						if (t == '院线电影') {
							storage.set('theme', '1')
						}
						if (t == '网络电影') {
							storage.set('theme', '2')
						}
						if (t == '数字电影') {
							storage.set('theme', '3')
						}
						if (t == '电视剧') {
							storage.set('theme', '4')
						}
						if (t == '网络剧') {
							storage.set('theme', '5')
						}
						if (t == '广告拍摄') {
							storage.set('theme', '6')
						}
						if (t == 'MV拍摄') {
							storage.set('theme', '7')
						}
						if (t == '综艺节目') {
							storage.set('theme', '8')
						}
						if (t == '演出活动') {
							storage.set('theme', '9')
						}
						if (t == '其他') {
							storage.set('theme', '10')
						}

					},
					err => {
						console.log(err)
					}
				)
			},
		},
		mounted() {
			var id = this.$route.params.id;
			storage.set('id', id) //指定影片信息id
			this.requestData(id)
		},
	}
</script>
<style scoped>
	.el-icon-minus {
		margin-top: 6px !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/group_admin/G_GroupInfor.vue